<template>
  <div>
    <spinner-round
      v-if="loading"
      :is-loading="loading" />
    <template v-else>
      <page-nav-bar
        v-if="program"
        :is-sticky="true"
        :back-button="true"
        :has-actions="isPromoteur && isAdmin"
        :title="program.name"
        :hide-separators="true">
        <template slot="before-actions">
          <router-link
            v-if="program.status !== 'archived'"
            class="page-header-btn is-small is-border-left"
            :to="{name: 'DenunciationCreate', query: {program: program.pk}}">
            <span class="">Dénoncer contact</span>
          </router-link>
        </template>
        <template v-if="program.status === 'archived'">
          <a
            id="programEditButton"
            slot="dropdown-content"
            @click="unarchive"
            class="dropdown-item">
            <span class="icon is-medium"><i class="fas fa-edit" /></span><span class="is-margin-left-xsmall">Désarchiver {{ nameToUse }}</span>
          </a>
        </template>
        <template v-else>
          <router-link
            v-if="isPromoteurDetailsActivated"
            slot="label"
            :to="{name: 'PromoteurPresentation', params: {id: program.promoteur.pk}}">
            <span>- {{ program.promoteur.name }}</span>
          </router-link>
          <span
            v-if="!isPromoteur && !isPromoteurDetailsActivated"
            slot="label"> - {{ program.promoteur.name }}</span>
          <router-link
            id="programEditButton"
            slot="dropdown-content"
            :to="{name: 'ProgramEdit', params: {id: program.pk}}"
            class="dropdown-item">
            <span class="icon is-medium"><i class="fas fa-edit" /></span><span class="is-margin-left-xsmall">Modifier fiche</span>
          </router-link>
          <router-link
            id="programCustomDoc"
            slot="dropdown-content"
            :to="{name: 'ProgramCustomDocVue', params: {id: program.pk}}"
            class="dropdown-item">
            <span class="icon is-medium"><i class="fas fa-folder-open"></i></span><span class="is-margin-left-xsmall">Modifier documents personnalisés</span>
          </router-link>
          <router-link
            id="lotCreateButton"
            slot="dropdown-content"
            :to="{name: 'LotParkingCreate', query: {program: program.pk}}"
            class="dropdown-item">
            <span class="icon is-medium"><i class="fas fa-plus-circle is-size-5" /></span>
            <span class="is-margin-left-xsmall">Ajouter lot et parking</span>
          </router-link>
          <router-link
            slot="dropdown-content"
            :to="{name: 'ProgramDiffusionEdit', params: {id: program.pk}}"
            class="dropdown-item">
            <span class="icon is-medium"><i class="fas fa-rss" /></span>
            <span class="is-margin-left-xsmall">Communication</span>
          </router-link>
          <router-link
            v-if="canUseBuyerSpace && !preProdEnv"
            slot="dropdown-content"
            :to="{name: 'ProgramBuyerSpace', params: {id: program.pk}}"
            class="dropdown-item">
            <span class="icon is-medium"><i class="fas fa-user-lock" /></span>
            <span class="is-margin-left-xsmall">Espace Acquéreur</span>
          </router-link>
          <a
            v-if="(publicUrl && publicEnabled) && !preProdEnv"
            slot="dropdown-content"
            target="_blank"
            class="dropdown-item"
            :href="publicUrl">
            <span class="icon is-medium"><i class="fas fa-browser" /></span>
            <span class="is-margin-left-xsmall">Site public</span>
          </a>
          <a
            slot="dropdown-content"
            class="dropdown-item"
            @click="xlsExportUrl">
            <span class="icon is-medium"><i class="fas fa-file-export" /></span>
            <span class="is-margin-left-xsmall">Exporter données {{ nameToUse }}</span>
          </a>
          <a
            v-if="alertToUse === true"
            slot="dropdown-content"
            class="dropdown-item"
            @click="disableAlert">
            <span class="icon is-medium"><i class="fas fa-unlink" /></span>
            <span class="is-margin-left-xsmall">Ne pas suivre ce programme</span>
          </a>
          <a
            v-else
            slot="dropdown-content"
            class="dropdown-item"
            @click="activateAlert">
            <span class="icon is-medium"><i class="fas fa-link" /></span>
            <span class="is-margin-left-xsmall">Suivre ce programme</span>
          </a>
          <a
            id="programDeleteButton"
            slot="dropdown-content"
            class="dropdown-item has-background-danger has-text-white"
            @click.prevent.stop="deleteProgram(program)">
            <span class="icon is-medium"><i class="fas fa-trash-alt" /></span><span class="is-margin-left-xsmall">Supprimer</span>
          </a>
        </template>
      </page-nav-bar>
      <program-promoteur-vue
        v-if="isPromoteur && isAdmin"
        :program="program"
        @updateProgram="updateProgram" />
      <program-distributeur-vue
        v-else
        :program="program" />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { downloadXlsFromApi } from '@/utils'

export default {
  name: 'ProgramVue',
  components: {
    ProgramPromoteurVue: () => import('./ProgramPromoteurVue'),
    ProgramDistributeurVue: () => import('./ProgramDistributeurVue')
  },
  data () {
    return {
      loading: false,
      program: null,
      publicEnabled: false,
      publicUrl: null,
      isPromoteurDetailsActivated: false,
      alert: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur', 'canUseBuyerSpace', 'accounts', 'preProdEnv']),
    ...mapState(['currentUser']),
    programPk () {
      return this.$route.params.id
    },
    nameToUse () {
      if (this.program && this.program.is_amenagement) {
        return 'lotissement'
      } else {
        return 'programme'
      }
    },
    alertToUse () {
      let alertDisable
      if (this.currentUser.disable_program_alert !== null) {
        alertDisable = this.currentUser.disable_program_alert.indexOf(this.program.pk)
        if (!alertDisable || alertDisable !== -1) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }
  },
  watch: {
    '$route.params.id' (v) {
      this.initProgram()
    }
  },
  created () {
    this.initProgram()
  },
  methods: {
    async initProgram () {
      await this.getProgram()
      await this.getProgramSiteParams()
    },
    async getProgramSiteParams () {
      const publicRoot = this.$configs.VADIMM_PUBLIC || 'https://public.vadimm.dev'
      try {
        const { data } = await this.$api.get(this.$resources.PROGRAM_SITE_PARAMS(this.programPk))
        this.publicEnabled = data.enabled
        this.publicUrl = `${publicRoot}/programs/${this.programPk}`
      } catch (e) {
        console.log(e)
      }
    },
    async updateProgram (data) {
      this.program = Object.assign({}, data)
    },
    async getProgram () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.PROGRAM, this.programPk)
        this.program = data
        this.isPromoteurDetailsActivated = data.promoteur_details_activated
      } catch (e) {
        console.log(e)
        this.$router.replace({ name: 'NotFound' })
      } finally {
        this.loading = false
      }
    },
    async xlsExportUrl () {
      try {
        const { data } = await this.$api.exportOneXls(this.$resources.PROGRAM, this.program.pk)
        downloadXlsFromApi(data, `Export ${this.program.name}`)
      } catch (e) {
        console.log(e)
      }
    },
    async deleteProgram (program) {
      try {
        const { value } = await this.$swal({
          title: `Suppression ${this.nameToUse}`,
          text: 'Le ' + this.nameToUse + ' ne sera plus consultable, les mandats, options, dénonciations qui lui sont liées seront automatiquement annulés. Si le ' + this.nameToUse + ' contient des ventes, la suppression du ' + this.nameToUse + ' ne sera pas possible. Dans ce cas, un archivage sera appliqué afin de conserver l’historique tout en le retirant de l’exploitation courante.',
          focusConfirm: false,
          customClass: {
            confirmButton: 'is-danger'
            // cancelButton: 'button is-primary'
          }
        })
        if (value && value.dismiss) return false // Cancel delete program process
        if (value) {
          try {
            const response = await this.$api.delete(this.$resources.PROGRAM, program.pk)
            if (response === 'delete') {
              this.$toasted.global.success(this.nameToUse + ' supprimé')
            } else {
              this.$toasted.global.success(this.nameToUse + ' archivé')
            }
            this.$router.push({ name: 'ProgramCardList' })
          } catch (e) {
            this.handleError(e)
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async disableAlert () {
      if (this.currentUser.disable_program_alert !== null) {
        let disableAlert = this.currentUser.disable_program_alert
        const resultAlert = disableAlert.indexOf(this.program.pk)
        if (resultAlert === -1) {
          if (this.disableAlert.length > 0 || this.disableAlert === null) {
            this.currentUser.disable_program_alert = this.program.pk
          } else {
            this.currentUser.disable_program_alert.push(this.program.pk)
          }
          try {
            await this.$api.put(this.$resources.USER, this.currentUser.pk, this.currentUser)
            this.$toasted.global.success('Notifications programme désactivées')
          } catch (e) {
            console.log(e)
          }
        }
      } else {
        this.currentUser.disable_program_alert = []
        this.currentUser.disable_program_alert.push(this.program.pk)
        try {
          await this.$api.put(this.$resources.USER, this.currentUser.pk, this.currentUser)
          this.$toasted.global.success('Notifications programme désactivées')
        } catch (e) {
          console.log(e)
        }
      }
    },
    async activateAlert () {
      const alert = this.currentUser.disable_program_alert.indexOf(this.program.pk)
      if (alert !== -1) {
        try {
          this.currentUser.disable_program_alert = this.currentUser.disable_program_alert.filter(x => x !== this.program.pk)
          await this.$api.put(this.$resources.USER, this.currentUser.pk, this.currentUser)
          this.$toasted.global.success('Notifications programme activées')
        } catch (e) {
          console.log(e)
        }
      }
    },
    async unarchive () {
      try {
        const { value } = await this.$swal({
          title: `Désarchiver ${this.nameToUse}`,
          text: 'Êtes vous sur de vouloir désarchiver ce ' + this.nameToUse + '',
          focusConfirm: false,
          customClass: {
            confirmButton: 'is-danger'
          }
        })
        if (value && value.dismiss) return false
        if (value) {
          try {
            const payload = {
              status: 'draft'
            }
            await this.$api.patch(this.$resources.PROGRAM, this.programPk, payload)
            this.$router.push({ name: 'ProgramCardList' })
          } catch (error) {
            this.handleError(error)
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
